<template>
  <div class="container-fluid py-4">

    <!-- HEADER -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-cash-coin fs-2 text-success"></i>
        <h2 class="fw-bold mb-0">Paiements</h2>
      </div>

      <button class="btn btn-success me-2" @click="exportCsv" v-if="$store.getters.hasPermission('TRANS_LIST_AUTRES_SERVICES_EXPORT')">
  <i class="bi bi-file-earmark-excel me-2"></i> Export Excel
</button>

      <button class="btn btn-primary" @click="imprimerPaiements" v-if="$store.getters.hasPermission('TRANS_LIST_AUTRES_SERVICES_IMPRESSION')">
        <i class="bi bi-printer me-2"></i> Imprimer
      </button>
    </div>

    <!-- FILTRES -->
    <div class="card p-3 mb-4 shadow-sm rounded card-clinique">
      <div class="row g-3 align-items-end">

        <div class="col-12 col-md-3">
          <label class="form-label fw-semibold">Rechercher patient</label>
          <input v-model="searchQuery" class="form-control" placeholder="Nom, prénom..." />
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Date début</label>
          <input type="date" v-model="dateDebut" class="form-control" />
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Date fin</label>
          <input type="date" v-model="dateFin" class="form-control" />
        </div>

        <div class="col-12 col-md-3">
          <label class="form-label fw-semibold">Assurance</label>
          <select v-model="assuranceFilter" class="form-select">
            <option value="">Toutes les assurances</option>
            <option v-for="a in assurances" :key="a.id" :value="a.nom">
              {{ a.nom }}
            </option>
          </select>
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Items / page</label>
          <select v-model="itemsperpage" class="form-select">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>

      </div>
    </div>

    <!-- LOADER -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary"></div>
      <p>Chargement...</p>
    </div>

    <!-- TABLE -->
    <div v-else class="card shadow-sm rounded">

      <!-- TOTAUX -->
      <div class="row m-3 g-3">

        <div class="col-md-4">
          <div class="total-box text-center">
            Total Patient
            <span class="d-block text-success fs-5">
              {{ totalPatient.toLocaleString() }} FCFA
            </span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="total-box text-center">
            Total Assurance
            <span class="d-block text-primary fs-5">
              {{ totalAssurance.toLocaleString() }} FCFA
            </span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="total-box text-center">
            Total Global
            <span class="d-block text-dark fs-5">
              {{ (totalPatient + totalAssurance).toLocaleString() }} FCFA
            </span>
          </div>
        </div>

      </div>

      <!-- TABLEAU -->
      <div class="table-responsive">
        <table class="table table-bordered table-hover align-middle text-center">

          <thead class="table-primary">
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Patient</th>
              <th>Ref</th>
              <th>Montant base</th>
              <th>Type</th>
              <th>Assurance</th>
              <th>Part Assurance</th>
              <th>Part Patient</th>
              <th>N° assurance</th>
              <th>Mode de paiement</th>
              <th>Statut</th>
              <th>Enregistré par</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(p, index) in filteredPaiements" :key="p.id">
  <td>{{ index + 1 }}</td>
  <td>{{ formatDate(p.createdAt) }}</td>
  <td>{{ p.patientNom }} {{ p.patientPrenom }}</td>
  <td>
     <span v-if="p.type =='Facture servive'">{{ p.numFacture }}</span>
     <span v-else="p.type =='Facture servive'">{{ p.ref }}</span>
    </td>
    <td class="fw-bold text-danger">
    {{ ((p.montantBase || 0)).toLocaleString() }}
  </td>
  <td>{{ p.type }}</td>
  <td>{{ p.assuranceNom || '—' }} - {{ p.tauxCouverture }} %</td>

  <td class="fw-bold text-primary">
    {{ (p.partAssurance || 0).toLocaleString() }}
  </td>

  <td class="fw-bold text-success">
    {{ (p.partPatient || 0).toLocaleString() }}
  </td>
  <td>
    {{ p.numeroAssurance || '_' }}
  </td>
  <td>
    {{ p.modePaiementNom || '_' }}
  </td>
  <td>
  <span 
    class="badge"
    :class="getStatutClass(p.statut)"
  >
    {{ p.statut }}
  </span>
</td>

  <td>{{ p.userNom }} {{ p.userPrenom }}</td>
</tr>


            <tr v-if="paiements.length === 0">
              <td colspan="9">Aucune donnée trouvée</td>
            </tr>
          </tbody>

        </table>
      </div>

    </div>

  </div>
</template>
<script>
import api from "@/api";
import dayjs from "dayjs";

export default {
  data() {
    return {
      isLoading: true,
      searchQuery: "",
      dateDebut: dayjs().format("YYYY-MM-DD"),
      dateFin: "",
      assuranceFilter: "",
      paiements: [],
      itemsperpage: 30,
      itemsPerPageT: [30, 60, 90],
      assurances: []
    };
  },

  computed: {

  filteredPaiements() {
    let list = this.paiements;

    if (this.searchQuery) {
      const q = this.searchQuery.toLowerCase();
      list = list.filter(p =>
        `${p.patientNom} ${p.patientPrenom}`.toLowerCase().includes(q) || p.type.toLowerCase().includes(q)
      );
    }

    if (this.assuranceFilter) {
      list = list.filter(p => p.assuranceNom === this.assuranceFilter);
    }

    if (this.dateDebut) {
      list = list.filter(p => new Date(p.createdAt) >= new Date(this.dateDebut));
    }

    if (this.dateFin) {
      const fin = new Date(this.dateFin);
      fin.setHours(23, 59, 59);
      list = list.filter(p => new Date(p.createdAt) <= fin);
    }

    return list;
  },

  totalPatient() {
  return this.filteredPaiements
    .filter(p => this.estValide(p))
    .reduce((t, p) => t + Number(p.partPatient || 0), 0);
},

 totalAssurance() {
  return this.filteredPaiements
    .filter(p => this.estValide(p))
    .reduce((t, p) => t + Number(p.partAssurance || 0), 0);
}

}
,

  methods: {

    formatDate(date) {
      return dayjs(date).format("DD-MM-YYYY HH:mm");
    },
    estValide(p) {
  return p.statut?.trim()?.toUpperCase() !== 'ANNULE';
},

    async getPaiements() {
      try {
        this.isLoading = true;
        const res = await api.getItems("paiements");
        this.paiements = res.data.data;
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    getStatutClass(statut) {
    switch ((statut || '').toUpperCase()) {
      case 'CONFIRMER':
      case 'payee':
      case 'VALIDE':
        return 'bg-success';

      case 'ANNULEE':
        return 'bg-danger';
      case 'PARTIEL':
        return 'bg-primary';

      case 'EN_ATTENTE':
        return 'bg-warning';

      default:
        return 'bg-secondary';
    }
  },
   imprimerPaiements() {

  const paiements = this.filteredPaiements;

  if (!paiements.length) {
    alert("Aucune donnée à imprimer !");
    return;
  }

  const totalPatient = this.totalPatient;
  const totalAssurance = this.totalAssurance;

  const dateDebut = this.dateDebut
    ? this.formatDate(this.dateDebut)
    : "—";

  const dateFin = this.dateFin
    ? this.formatDate(this.dateFin)
    : "—";

  const rowsHtml = paiements.map((p, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${this.formatDate(p.createdAt)}</td>
      <td>${p.patientNom} ${p.patientPrenom}</td>
      <td>${Number(p.montantBase || 0).toLocaleString()}</td>
      <td>${p.type || ""}</td>
      <td>${p.assuranceNom || "—"}</td>
      <td class="assurance">${Number(p.partAssurance || 0).toLocaleString()}</td>
      <td class="patient">${Number(p.partPatient || 0).toLocaleString()}</td>
      <td>${p.userNom || ""} ${p.userPrenom || ""}</td>
    </tr>
  `).join("");

  const htmlContent = `
  <html>
  <head>
    <title>Impression Paiements</title>

    <style>
      @page {
        size: A4;
        margin: 2.5cm;
      }

      body {
        font-family: Arial, sans-serif;
        font-size: 13px;
        color: #333;
      }

      h2 {
        text-align: center;
        color: #198754;
        margin-bottom: 5px;
      }

      .periode {
        text-align: center;
        font-size: 14px;
        margin-bottom: 15px;
        font-weight: bold;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
      }

      th, td {
        border: 1px solid #ccc;
        padding: 6px;
        text-align: center;
      }

      th {
        background: #e9f2ff;
        font-weight: bold;
      }

      .patient {
        color: #198754;
        font-weight: bold;
      }

      .assurance {
        color: #0d6efd;
        font-weight: bold;
      }

      .totaux {
        margin-top: 25px;
        display: flex;
        justify-content: space-between;
        font-size: 15px;
        font-weight: bold;
      }

      .box {
        border: 2px solid #198754;
        padding: 10px 15px;
        border-radius: 6px;
        width: 48%;
        text-align: center;
      }

      footer {
        margin-top: 30px;
        text-align: center;
        font-size: 12px;
        border-top: 1px solid #ccc;
        padding-top: 8px;
      }
    </style>
  </head>

  <body>

    <h2>LISTE DES PAIEMENTS</h2>

    <div class="periode">
      Période des paiements : du ${dateDebut} au ${dateFin}
    </div>

    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>Date</th>
          <th>Patient</th>
          <th>Montant Base</th>
          <th>Type</th>
          <th>Assurance</th>
          <th>Part Assurance</th>
          <th>Part Patient</th>
          <th>Enregistré par</th>
        </tr>
      </thead>
      <tbody>
        ${rowsHtml}
      </tbody>
    </table>

    <div class="totaux">
      <div class="box">
        TOTAL PATIENT <br>
        <span style="color:#198754">
          ${totalPatient.toLocaleString()} FCFA
        </span>
      </div>

      <div class="box">
        TOTAL ASSURANCE <br>
        <span style="color:#0d6efd">
          ${totalAssurance.toLocaleString()} FCFA
        </span>
      </div>
    </div>

    <footer>
      <p>Impression effectuée le ${new Date().toLocaleString()} par </p>
    </footer>

  </body>
  </html>
  `;

  const printWindow = window.open("", "_blank");
  printWindow.document.write(htmlContent);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
}

,

    async getAssurances() {
      const res = await api.getItems("assurances");
      this.assurances = res.data.data;
    },
  exportCsv() {
  const rows = this.filteredPaiements.filter(p => this.estValide(p));

  if (!rows.length) {
    alert("Aucune donnée à exporter !");
    return;
  }

  const dateDebut = this.dateDebut
    ? dayjs(this.dateDebut).format("DD-MM-YYYY")
    : "—";

  const dateFin = this.dateFin
    ? dayjs(this.dateFin).format("DD-MM-YYYY")
    : "—";

  const headers = [
    "Date",
    "Patient",
    "Ref",
    "Montant Base",
    "Type",
    "Assurance",
    "Part Assurance",
    "Part Patient",
    "N° Assurance",
    "Statut",
    "Enregistré par"
  ];

  const data = rows.map(p => [
    this.formatDate(p.createdAt),
    `${p.patientNom} ${p.patientPrenom}`,
    p.ref,
    p.montantBase || 0,
    p.type || "",
    p.assuranceNom || "",
    p.partAssurance || 0,
    p.partPatient || 0,
    p.numeroAssurance || "",
    p.statut || "",   
    `${p.userNom || ""} ${p.userPrenom || ""}`
  ]);

  const totalPatient = this.totalPatient || 0;
  const totalAssurance = this.totalAssurance || 0;
  const totalGlobal = totalPatient + totalAssurance;

  const csv =
    "\uFEFF" +
    `LISTE DES PAIEMENTS\n` +
    `Période;Du ${dateDebut};Au ${dateFin}\n\n` +

    headers.join(";") + "\n" +
    data.map(row => row.join(";")).join("\n") +

    "\n\n" +
    "RÉCAPITULATIF\n" +
    `Total Patient;${totalPatient}\n` +
    `Total Assurance;${totalAssurance}\n` +
    `Total Global;${totalGlobal}\n`;

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `paiements_${dateDebut}_${dateFin}.csv`;
  link.click();

  URL.revokeObjectURL(url);
}




    
  },
  

  created() {
    this.getPaiements();
    this.getAssurances();
  }
};
</script>
<style>
.total-box {
  font-size: 16px;
  font-weight: bold;
  padding: 10px;
  border: 2px solid #198754;
  border-radius: 6px;
  background: #eefaf1;
}
</style>
